module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Light.woff2";